import { enumSchema } from '@shared/utils/enum.utils';

import { Currency } from '../enums/currency.enum';

export interface Money {
  amount: number;
  currency: Currency;
}

export const currencySchema = enumSchema('Currency', Currency);

export function getMoneySchema(additionalDescription?: string) {
  return {
    type: 'object',
    description: 'Money object with amount and currency. ' + (additionalDescription ?? ''),
    properties: {
      amount: { type: 'number', description: 'Numeric monetary amount.' },
      currency: currencySchema,
    },
  };
}
